import cx from 'classnames';
import React from 'react';

import styles from './header.module.scss';

export function SkipNavButton() {
  return (
    <a
      href="#main-content"
      id="focusButton"
      className={cx('btn btn-success', styles.skipButton)}
    >
      Skip to main content
    </a>
  );
}
